"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React, { useRef, useEffect } from "react";
import { Play, Calendar, Flag, Trophy, Activity, ChevronLeft, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const galleryItems = [{
  id: 1,
  src: "https://newwavecamp.com/wp-content/uploads/2026/03/486262863_18334916089095949_2860809319678896016_n.jpg?v=1wmdahuk7gr",
  alt: "Intensywny trening Muay Thai",
  type: "image"
}, {
  id: 2,
  src: "https://newwavecamp.com/wp-content/uploads/2026/03/534429808_1604414497609209_7800570444901686476_n.jpg?v=uwf38qwjgt",
  alt: "Rajska plaża na Koh Samui",
  type: "image"
}, {
  id: 5,
  src: "https://newwavecamp.com/wp-content/uploads/2026/03/134806498_3890974240965585_8794601036364297643_n.jpg?v=snm55j5e3y",
  alt: "Krystalicznie czysta woda",
  type: "image"
}, {
  id: 6,
  src: "https://newwavecamp.com/wp-content/uploads/2026/03/511153462_24301656942804015_4053319695225706963_n.jpg?v=m8djhsv4okc",
  alt: "Dawid Kasperski w akcji",
  type: "image"
}, {
  id: 7,
  src: "https://newwavecamp.com/wp-content/uploads/2026/03/Zrzut-ekranu-910.png?v=xfaaye9q7ih",
  alt: "Lokalna kultura i świątynie",
  type: "image"
}, {
  id: 8,
  src: "https://newwavecamp.com/wp-content/uploads/2026/03/Zrzut-ekranu-912.png?v=5dv2n1evs15",
  alt: "Plaża Chaweng na Koh Samui",
  type: "image"
}, {
  id: 9,
  src: "https://newwavecamp.com/wp-content/uploads/2026/03/468668420_18320957881095949_4341471590618779067_n.jpg?v=vw3mk46aff",
  alt: "Widok na sąsiednią wyspę Koh Phangan",
  type: "image"
}, {
  id: 11,
  src: "https://newwavecamp.com/wp-content/uploads/2026/03/514220595_24342869295349446_7433641304548161971_n.jpg?v=k19vrxn8zsn",
  alt: "Wieczorne życie na Walking Street",
  type: "image"
}, {
  id: 12,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583198/img/image_yimqw9vc.jpg",
  alt: "Tropikalna natura i egzotyczne krajobrazy",
  type: "image"
}, {
  id: 13,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583198/img/muay_thai_training_session_samui.png",
  alt: "Poranny trening Muay Thai na Koh Samui",
  type: "image"
}, {
  id: 14,
  src: "https://newwavecamp.com/wp-content/uploads/2026/03/927C9A88-1E7E-4DDD-A799-BFD795C0570E-1.jpg?v=m4732b9isj",
  alt: "Widok na rajską plażę w pobliżu obozu",
  type: "image"
}, {
  id: 15,
  src: "https://newwavecamp.com/wp-content/uploads/2026/03/468939734_18320975656095949_6106965483361729066_n-1.jpg?v=u6iwlbvi8ah",
  alt: "Akcja na ringu w klubie Lamai Muay Thai",
  type: "image"
}, {
  id: 16,
  src: "https://newwavecamp.com/wp-content/uploads/2026/03/4c19c70c-40d4-4565-977e-cf28f235a84f-1.jpg?v=p0qgomc230d",
  alt: "Wycieczka łodzią wokół wysp Koh Samui",
  type: "image"
}, {
  id: 17,
  src: "https://newwavecamp.com/wp-content/uploads/2026/03/41c81a8a-43ef-4a55-ba09-14423b66b6b9-1.jpg?v=d4kda5nyhki",
  alt: "Trening technik klinczu pod okiem mistrza",
  type: "image"
}];
function Carousel({
  items
}: {
  items: typeof galleryItems;
}) {
  const scrollRef = useRef<HTMLDivElement>(null);
  const scroll = (direction: "left" | "right") => {
    if (scrollRef.current) {
      const {
        scrollLeft,
        clientWidth
      } = scrollRef.current;
      const scrollAmount = clientWidth;
      const scrollTo = direction === "left" ? scrollLeft - scrollAmount : scrollLeft + scrollAmount;
      scrollRef.current.scrollTo({
        left: scrollTo,
        behavior: "smooth"
      });
    }
  };
  useEffect(() => {
    if (window.innerWidth < 768) {
      const interval = setInterval(() => {
        scroll("right");
      }, 5000);
      return () => clearInterval(interval);
    }
  }, []);
  return <div className="relative group">
      <div ref={scrollRef} className="flex overflow-x-auto snap-x snap-mandatory gap-6 scroll-smooth [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden pb-4">
        {items.map((item, i) => <div key={item.id} data-index={i} className="flex-none w-full sm:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)] snap-center">
            <div className="relative overflow-hidden rounded-xl group bg-muted aspect-[4/3] shadow-lg">
              <img src={item.src} alt={item.alt} className={`w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ${["Trening technik klinczu pod okiem mistrza", "Wycieczka łodzią wokół wysp Koh Samui", "Akcja na ringu w klubie Lamai Muay Thai"].includes(item.alt) ? "object-top" : ""}${i === 12 ? " mx-auto" : ""}`} loading="lazy" width={i === 12 ? "410" : undefined} height={i === 12 ? "307" : undefined} />
            </div>
          </div>)}
      </div>

      <button onClick={() => scroll("left")} className="absolute left-4 top-1/2 -translate-y-1/2 bg-transparent backdrop-blur-sm p-3 rounded-full border border-border opacity-0 group-hover:opacity-100 transition-opacity z-10 hover:bg-primary hover:text-primary-foreground flex items-center justify-center cursor-pointer shadow-xl" aria-label="Poprzednie zdjęcie">
        <ChevronLeft className="size-6" />
      </button>

      <button onClick={() => scroll("right")} className="absolute right-4 top-1/2 -translate-y-1/2 bg-transparent backdrop-blur-sm p-3 rounded-full border border-border opacity-0 group-hover:opacity-100 transition-opacity z-10 hover:bg-primary hover:text-primary-foreground flex items-center justify-center cursor-pointer shadow-xl" aria-label="Następne zdjęcie">
        <ChevronRight className="size-6" />
      </button>
    </div>;
}
export default function RajskieWyspy() {
  return <section id="rajskie-wyspy" className="dark bg-background text-foreground py-24 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold uppercase tracking-tight mb-4 text-primary">
            Galeria
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Poczuj klimat elitarnego obozu. Pot, krew na sali treningowej i
            rajskie widoki Koh Samui po godzinach.
          </p>
        </div>

        <Carousel items={galleryItems} />

        <div className="mt-24">
          <Card id="glowny-trener" className="overflow-hidden border-primary/20 bg-card/30 backdrop-blur-sm">
            <div className="flex flex-col lg:flex-row">
              <div className="lg:w-1/3 aspect-[4/5] lg:aspect-auto">
                <img src="https://newwavecamp.com/wp-content/uploads/2026/03/468844114_18320957086095949_1215576783640245770_n.jpg" alt="Dawid Kasperski Profile" className="w-full h-full object-cover hover:grayscale-0 transition-all duration-1000" />
              </div>
              <div className="flex-1 p-8 lg:p-12 flex flex-col justify-center">
                <CardHeader className="p-0 mb-8">
                  <div className="flex items-center gap-4 mb-2">
                    <div className="h-1 w-12 bg-primary"></div>
                    <span className="text-primary font-bold uppercase tracking-widest text-sm">
                      Główny Trener
                    </span>
                  </div>
                  <CardTitle className="text-4xl md:text-5xl font-bold uppercase tracking-tighter italic">
                    <Link to="/TrainerPage" className="hover:text-primary transition-colors">
                      Dawid Kasperski
                    </Link>
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-0">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6">
                    <div className="flex items-start gap-4">
                      <SafeHydrate><Calendar className="size-6 text-primary shrink-0 mt-1" /></SafeHydrate>
                      <div>
                        <p className="text-xs text-muted-foreground uppercase font-bold tracking-wider">
                          Data urodzenia
                        </p>
                        <p className="text-lg font-medium">7 lipca 1990</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4">
                      <Flag className="size-6 text-primary shrink-0 mt-1" />
                      <div>
                        <p className="text-xs text-muted-foreground uppercase font-bold tracking-wider">
                          Narodowość
                        </p>
                        <p className="text-lg font-medium">Polska</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4">
                      <Activity className="size-6 text-primary shrink-0 mt-1" />
                      <div>
                        <p className="text-xs text-muted-foreground uppercase font-bold tracking-wider">
                          Warunki fizyczne
                        </p>
                        <p className="text-lg font-medium">187 cm / 93 kg</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4">
                      <Trophy className="size-6 text-primary shrink-0 mt-1" />
                      <div>
                        <p className="text-xs text-muted-foreground uppercase font-bold tracking-wider">
                          Osiągnięcia
                        </p>
                        <p className="text-lg font-medium">21x Mistrz Polski, Puchar Świata WAKO, Złoty medal w The World Games,<br />Mistrz Europy, KSW Fighter</p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-10 pt-8 border-t border-white/5">
                    <p className="text-muted-foreground leading-relaxed italic">
                      &quot;Moim celem jest przekazanie wiedzy zdobytej na
                      największych arenach świata. W Nowej Fali łączymy
                      profesjonalizm z pasją do sportów walki.&quot;
                    </p>
                  </div>
                </CardContent>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}